import React from 'react';
import AddRuleItem from './AddRuleItem';

class Rule extends React.Component {
    constructor(props) {
        super(props);
        this.defaultState = this.defaultState.bind(this);
         this.editDropdown = this.editDropdown.bind(this);
        this.renderDropdown = this.renderDropdown.bind(this);
        this.changeDropdown = this.changeDropdown.bind(this);
        this.defaultState();
    }

    changeDropdown(value) {
        this.props.handleChange(this.props.rule.id,{
            ...this.props.rule,
            value:value,
        });

        this.setState({value:value});
        this.setState({'isEditingDropdown':!this.state.isEditingDropdown});
    }

    renderDropdown() {
        return (
            <div className="dropdown open">
                <button type="button" className="btn btn-dark dropdown-toggle btn-sm" aria-expanded="true" data-toggle="dropdown">
                    {this.state.value == 'true' ? 'is':'is not'}
                    <span className="caret"></span>
                </button>
                <div className="dropdown-menu">
                    <a href="javascript:void(0)" onClick={e => {e.stopPropagation(); this.changeDropdown('true')}} className="dropdown-item" role="button" tabIndex="-1">is</a>
                    <a href="javascript:void(0)" onClick={e => {e.stopPropagation(); this.changeDropdown('false')}} className="dropdown-item" role="button" tabIndex="-1">is not</a>
                </div>
            </div>
        );
    }

    editDropdown() {
        this.setState({'isEditingDropdown':!this.state.isEditingDropdown});
    }

    defaultState(props) {
        this.state = {
            'isEditingDropdown':false,
            'value':this.props.onlyDescription ? false:this.props.rule.value
        };      
    }

  

    render() {
        if(this.props.onlyDescription) {
            return <AddRuleItem select={this.props.addRule} value="true" operator="==" action="Who" ruleKey={this.props.ruleKey} title="Returning customers" description="Only show to returning customers" />
        }
        return (
                <div className="list-group-item blue-grey-500">    
                    <i className="icon wb-arrow-right" aria-hidden="true"></i>
                    Display to visitors who &nbsp;
                    {
                         !this.state.isEditingDropdown
                         ?
                         <span onClick={(e) => {e.stopPropagation();this.editDropdown(e);} } className="selected-rule">{this.props.rule.value == 'true' ? 'is':'is not'}</span>
                         :this.renderDropdown()
                    }
                    &nbsp;a returning visitor.
                    <div className="remove-rule"><a href="javascript:void(0)" onClick={e => {e.stopPropagation(); this.props.handleRemove(this.props.rule.id)}}><i className="icon wb-close"></i></a></div>
                </div>
        );
    }

  
}

export default Rule;




// WEBPACK FOOTER //
// ./components/builder/RuleShowToReturning.js